export function min(items: Array<number>): number | undefined {
    if (items.length === 0) return undefined;
    return items.reduce((acc, val) => {
        acc = acc === undefined || val < acc ? val : acc;
        return acc;
    }, items[0]);
}

export function max(items: Array<number>): number | undefined {
    if (items.length === 0) return undefined;
    return items.reduce((acc, val) => {
        acc = acc === undefined || val > acc ? val : acc;
        return acc;
    }, items[0]);
}

export function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max);
}

export function roundToNearestTen(value: number): number {
    return Math.round(value / 10) * 10;
}
